// DBのINTEGER型の最大値
export const MAX_INTEGER = 2147483647;
